import projectUtils from "../../../../utils/project-utils.js";

export function validateLatLng(lat, lng) {
    const latNum = Number(lat);
    const lngNum = Number(lng);

    if (!isFinite(latNum) || Math.abs(latNum) > 90) return false;
    if (!isFinite(lngNum) || Math.abs(lngNum) > 180) return false;

    return true;
}

export function validateContactId({ address, centralType, alarmCentral, fireCentral, isUpdate = false}) {
    if (!address?.place?.id && !address?.description) {
        projectUtils.swalErrorMessage("", 'O campo "Local pré-cadastrado" é obrigatório.');
        return false;
    }

    if (!address?.latitude) {
        projectUtils.swalErrorMessage("", 'O campo "Latitude" é obrigatório.');
        return false;
    }

    if (!address?.longitude) {
        projectUtils.swalErrorMessage("", 'O campo "Longitude" é obrigatório.');
        return false;
    }

    if (!validateLatLng(address.latitude, address.longitude)) {
        projectUtils.swalErrorMessage("", "Latitude ou Longitude inválidas.");
        return false;
    }

    if (!centralType && !isUpdate) {
        projectUtils.swalErrorMessage("", "O tipo de central é obrigatório.");
        return false;
    }

    if (centralType === "fire") {
        if (!fireCentral?.account) {
            projectUtils.swalErrorMessage("", 'O campo "Endereço físico" é obrigatório.')
            return false;
        }

        if (!fireCentral?.fireCenterDriver) {
            projectUtils.swalErrorMessage("", 'O campo "Fabricante" é obrigatório.');
            return false;
        }
    }

    if (centralType === "alarm") {
        if (!alarmCentral?.driver) {
            projectUtils.swalErrorMessage("", 'O campo "Fabricante" é obrigatório.');
            return false;
        }

        if (!alarmCentral?.partitions?.length) {
            projectUtils.swalErrorMessage("", "É necessário adicionar ao menos uma partição.");
            return false;
        }

        const emptyPartition = alarmCentral.partitions.find(
            p => !p.account || !p.partition
        );

        if (emptyPartition) {
            const message = !emptyPartition.account
                ? 'O campo "Conta" é obrigatório.'
                : 'O campo "Partição" é obrigatório.';

            projectUtils.swalErrorMessage("", message);
            return false;
        }

        const nonPrimaryPartitions = alarmCentral.partitions.filter(
            p => !p.isPrimary
        );

        if (nonPrimaryPartitions.length > 0 && alarmCentral.driver?.toUpperCase() !== "INTELBRAS") {
            projectUtils.swalMessage("warning", "", "Novas partições estão disponíveis apenas para fabricante Intelbras.");
            return false;
        }

        for (const user of alarmCentral.users || []) {
            if (!user.id) {
                projectUtils.swalErrorMessage("", 'O campo "ID" do usuário é obrigatório.');
                return false;
            }
            if (!user.name) {
                projectUtils.swalErrorMessage("", 'O campo "Nome" do usuário é obrigatório.');
                return false;
            }
        }

        for (const sector of alarmCentral.sectors || []) {
            if (!sector.id) {
                projectUtils.swalErrorMessage("", 'O campo "ID" do setor é obrigatório.');
                return false;
            }
            if (!sector.name) {
                projectUtils.swalErrorMessage("", 'O campo "Nome" do setor é obrigatório.');
                return false;
            }
            if (!sector.type) {
                projectUtils.swalErrorMessage("", 'O campo "Tipo" do setor é obrigatório.');
                return false;
            }
        }
    }

    return true;
}